import React, { createContext, useContext, type ReactNode } from "react";

import {
  useMarketMonitorLive,
  type MarketMonitorLiveContext as ContextValue,
} from "./useMarketMonitorLive";

const Ctx = createContext<ContextValue | null>(null);

export const MarketMonitorLiveProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const value = useMarketMonitorLive();
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useMarketMonitorLiveContext = (): ContextValue => {
  const v = useContext(Ctx);
  if (!v) {
    return {
      enabled: false,
      client: null,
      status: "idle",
      cadence: "seconds_10",
      setCadence: () => {},
      tagStates: {},
      resetTagState: () => {},
    };
  }
  return v;
};
